export default __webpack_public_path__ + "b50c39010a5b8463bdb3edea79b16076.svg";